import { ResolveResource } from './utils'
import { getInstance } from '@/auth'
import Factory from './utils/Factory'
const resource = ResolveResource(__filename)

import fetch from '@/fetch'

export default new Factory(resource, {
  async verify(payload = {}) {
    let { email } = payload
    let instance = getInstance()
    return fetch(`/api/auth/verify/${email}`, {
      headers: { authorization: `Bearer ${await instance.getTokenSilently()}` },
    })
  },

  signup(payload = {}) {
    let { token, password } = payload
    return fetch('/api/auth/signup/' + token, {
      method: 'POST',
      body: JSON.stringify({ password }),
    })
  },

  reconfirm(payload = {}) {
    let { id } = payload
    return fetch('/api/auth/reconfirm/' + id, { method: 'POST' })
  },

  emailAvailable(payload = {}) {
    let { email } = payload
    return fetch('/api/user/validate/' + email)
  },
})
